/** The languages with a catalog the build ships, such as `en` or `en_peac_us_inc`. */
export const CATALOGS: ReadonlySet<string> = new Set(
  import.meta.env.I18N_CATALOGS
);
